import { render, staticRenderFns } from "./Ratio.vue?vue&type=template&id=560c35a6&scoped=true&"
import script from "./Ratio.vue?vue&type=script&lang=js&"
export * from "./Ratio.vue?vue&type=script&lang=js&"
import style0 from "./Ratio.vue?vue&type=style&index=0&id=560c35a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c35a6",
  null
  
)

export default component.exports